export const palette = {
  surface: 'bg-white',
  surfaceMuted: 'bg-nightshade-50',
  border: 'ring-1 ring-nightshade-200',
  borderSubtle: 'border border-nightshade-200',
  textPrimary: 'text-content-primary',
  textSecondary: 'text-content-secondary',
  textMuted: 'text-content-placeholder',
  accentIndigo: 'bg-blueberry-50 text-blueberry-700',
  accentSky: 'bg-blueberry-50 text-blueberry-900',
};

export const radii = {
  lg: 'rounded-2xl',
  md: 'rounded-xl',
  sm: 'rounded-md',
  pill: 'rounded-full',
};

export const shadows = {
  base: 'shadow-sm',
  hover: 'shadow-lg',
};

export const typography = {
  headingLg: 'text-2xl font-semibold tracking-tight text-nightshade-950',
  headingMd: 'text-lg font-semibold text-nightshade-950',
  headingSm: 'text-sm font-semibold uppercase tracking-wide text-nightshade-500',
  body: 'text-sm text-nightshade-600',
  caption: 'text-xs text-nightshade-500',
};

export const buttonVariants = {
  indigo:
    'bg-blueberry-500 text-white hover:bg-blueberry-600 border border-blueberry-500 focus-visible:ring-blueberry-400',
  primary:
    'bg-blueberry-500 text-white hover:bg-blueberry-600 border border-blueberry-500 focus-visible:ring-blueberry-400',
  success:
    'bg-matcha-500 text-white hover:bg-matcha-600 border border-matcha-500 focus-visible:ring-matcha-400',
  danger:
    'bg-pomegranate-600 text-white hover:bg-pomegranate-700 border border-pomegranate-600 focus-visible:ring-pomegranate-500',
  successOutline:
    'bg-white text-matcha-600 hover:bg-matcha-50 border border-matcha-500 focus-visible:ring-matcha-400',
  dangerOutline:
    'bg-white text-pomegranate-600 hover:bg-pomegranate-50 border border-pomegranate-500 focus-visible:ring-pomegranate-500',
  neutral:
    'bg-white text-nightshade-600 hover:bg-nightshade-100 border border-nightshade-300 focus-visible:ring-nightshade-400',
  ghost:
    'bg-transparent text-nightshade-600 hover:bg-nightshade-100 border border-transparent focus-visible:ring-nightshade-400',
  dangerGhost:
    'bg-transparent text-pomegranate-600 hover:bg-pomegranate-50 border border-transparent focus-visible:ring-pomegranate-500',
};

export const transitions = {
  default: 'transition ease-in-out duration-150',
};
